// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"f2d65958","453":"6c148b73","735":"054c596a"}[chunkId] + ".chunk.js";
};